import max from 'ml-array-max';
import { xRolling } from './xRolling';
/**
 * This function calculates a maximum within a rolling window
 *
 * @param array - the array that will be rotated
 * @param options - options
 */
export function xRollingMax(array, options = {}) {
    return xRolling(array, max, options);
}
//# sourceMappingURL=xRollingMax.js.map